import { useAppSelector } from 'app/hooks';
import { Header, Loader } from 'components';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { selectProfile } from 'redux/selectors/profile';

const WaitingPayment = (): JSX.Element => {
  const navigate = useNavigate();
  const user = useAppSelector(selectProfile);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 6000);
    return () => clearTimeout(timer);

  }, [user, navigate]);

  return (
    <>
      <Header withBackArrow={false}></Header>
      <div className="page">
        <div className="waiting-payment-container">
          <Loader />
          <p className="login-front-additional-text">Processing payment...</p>
        </div>
      </div>
    </>
  );
};

export default WaitingPayment;
